import { gql } from "@apollo/client";

export const GET_EVALUACION_PRECIO = gql`
query GetEvaluacionPrecio($idEvaluacion: Int!) {
  evaluacionPrecio (idEvaluacion: $idEvaluacion) {
    idEvaluacion,
    idPaciente,
    apellido,
    nombre,
    idDelegacion,
    delegacion,
    idPlanCuidado,
    planCuidado,
    fechaDesde,
    fechaHasta,
    idCliente,
    precioDiario 
  }
}
`;